import React from 'react';
import { PageHero } from '../components/PageHero';
import { SectionStage } from '../components/SectionStage';
import { InternalRunnerTeaser } from '../components/InternalRunnerTeaser';
export function InternalRunner() {
  return <>
      <PageHero eyebrow="Architecture" title="Internal Runner" titleMuted="Trust-forward design." description="Deploy the Periscan Internal Runner to validate internal reachability, segmentation, control response, fix status, and internal attack paths safely." bg="none" data-id="element-1611" />

      <SectionStage fx="circuit" data-id="element-1612">
        <InternalRunnerTeaser data-id="element-1613" />
      </SectionStage>

      {/* Placeholder for remaining sections: Runner lifecycle, Scope enforcement, Approved modules, Evidence upload, Deployment options, Security FAQ */}
    </>;
}